
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cars/ranking",
      function () {
        return require("private-next-pages/cars/ranking.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cars/ranking"])
      });
    }
  